<template>
  <footer class="footer-login">
    <div
      class="footer-text"
    >
      <span class="footer-title">
        {{ 'RTI2018-095298' }}
      </span>
      <br>
      <span class="footer-subtitle">
        {{ $t('text_description_login') }}
      </span>
    </div>
    <div class="content-bottom-img">
      <img
        class="ue"
      >
      <img
        class="cicytex"
      >
      <img
        class="investigation"
      >
      <img
        class="agencia"
      >
      <img
        class="cordoba"
      >
      <img
        class="ual"
      >
      <img
        class="ministerio"
      >
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/accounts/login.scss";
.ue{
  content: url("../static/img/ue.svg");
  width: auto;
  height: 100%;
}
.cicytex{
  content: url("../static/img/cicytex.svg");
  width: auto;
  height: 100%;
  margin: 1rem;
}
.investigation{
  content: url("../static/img/investigation.svg");
  width: auto;
  height: 60%;
  margin: 1rem;
}
.agencia{
  content: url("../static/img/agencia.svg");
  width: auto;
  height: 90%;
  margin: 1rem;
}
.cordoba{
  content: url("../static/img/cordoba.svg");
  width: auto;
  height: 90%;
  margin: 1rem;
}
.ual{
  content: url("../static/img/ual.svg");
  width: auto;
  height: 70%;
  margin: 1rem;
}
.ministerio{
  content: url("../static/img/ministerio.svg");
  width: auto;
  height: 80%;
  margin: 1rem;
}
</style>
